import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import SelectField from "components/form-control/Select";

const VVSAddress2 = props => {
  const {
    addressType,
    name,
    label,
    address,
    setAddress,
    errors,
    disabled,
    ...rest
  } = props;
  const { setValue } = rest;
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [wardList, setWardList] = useState([]);

  useEffect(async () => {
    let url = `https://cdn.jsdelivr.net/gh/thien0291/vietnam_dataset@1.0.0/Index.json`;
    const res = await axios.get(url);
    const provinceMap = Object.entries(res.data).map(([name, value], index) => {
      return {
        index,
        name,
        value: name,
        code: value.code,
      };
    });
    setProvinceList(provinceMap);

    if (address?.province) {
      const provinceSelected = provinceMap.find(
        p => p.value === address.province
      );

      if (!provinceSelected) return;

      let url = `https://cdn.jsdelivr.net/gh/thien0291/vietnam_dataset@1.0.0/data/${provinceSelected.code}.json`;
      const res = await axios.get(url);
      const districtMap = res.data.district.map((d, index) => ({
        index,
        name: d.name,
        value: d.name,
        ward: d.ward,
      }));
      setDistrictList(districtMap);
    }

    if (address?.district) {
      const provinceSelected = provinceMap.find(
        p => p.value === address.province
      );

      if (!provinceSelected) return;

      let url = `https://cdn.jsdelivr.net/gh/thien0291/vietnam_dataset@1.0.0/data/${provinceSelected.code}.json`;
      const res = await axios.get(url);

      const districtSelected = res.data.district.find(
        d => d.name === address.district
      );

      if (!districtSelected) return;

      const wardMap = districtSelected.ward.map((w, index) => ({
        index,
        name: w.name,
        value: w.name,
      }));
      setWardList(wardMap);
    }
    setValue("province", address.province);
    setValue("district", address.district);
    setValue("ward", address.ward);
  }, [address]);

  const handleAddressChange = e => {
    if (addressType === "province" || addressType === undefined) {
      setAddress({ ...address, province: e.target.value });
      setValue("district", "");
      setValue("ward", "");
    }
    if (addressType === "district") {
      setAddress({ ...address, district: e.target.value });
      setValue("ward", "");
    }
    if (addressType === "ward") {
      setAddress({ ...address, ward: e.target.value });
    }
  };

  const handleSelectOptions = () => {
    if (addressType === "province" || addressType === undefined)
      return provinceList;
    if (addressType === "district") return districtList;
    if (addressType === "ward") return wardList;
  };

  return (
    <SelectField
      label={label}
      name={name}
      errors={errors}
      disabled={disabled}
      {...rest}
      options={handleSelectOptions()}
      onChange={handleAddressChange}
    />
  );
};

VVSAddress2.propTypes = {
  addressType: PropTypes.string,
  address: PropTypes.object,
  register: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  errors: PropTypes.object,
  setAddress: PropTypes.func,
  disabled: PropTypes.bool,
};

export default VVSAddress2;
